import type { RefObject } from 'react';
import { findTransitionController } from '../../../../util/core-transition-component';

interface TextSlideRefs {
  topLeftTitleRef: RefObject<HTMLHeadingElement | null>;
  bottomRightTitleRef: RefObject<HTMLHeadingElement | null>;
  kanjiTextRef: RefObject<HTMLParagraphElement | null>;
}

export function setupTransitionInTimeline(
  timeline: gsap.core.Timeline,
  { topLeftTitleRef, bottomRightTitleRef, kanjiTextRef }: TextSlideRefs,
): void {
  const topLeftTitleController = findTransitionController(topLeftTitleRef);
  const bottomRightTitleController = findTransitionController(bottomRightTitleRef);
  const kanjiController = findTransitionController(kanjiTextRef);

  if (topLeftTitleController) {
    timeline.add(topLeftTitleController.getTimeline('in') as gsap.core.Timeline);
  }

  if (bottomRightTitleController) {
    timeline.add(bottomRightTitleController.getTimeline('in') as gsap.core.Timeline, 0.1);
  }

  if (kanjiController) {
    timeline.add(kanjiController.getTimeline('in') as gsap.core.Timeline, 0.1);
  }
}

export function setupTransitionOutTimeline(
  timeline: gsap.core.Timeline,
  { topLeftTitleRef, bottomRightTitleRef, kanjiTextRef }: TextSlideRefs,
): void {
  const topLeftTitleController = findTransitionController(topLeftTitleRef);
  const bottomRightTitleController = findTransitionController(bottomRightTitleRef);
  const kanjiController = findTransitionController(kanjiTextRef);

  if (topLeftTitleController) {
    timeline.add(topLeftTitleController.getTimeline('out') as gsap.core.Timeline, 0);
  }

  if (bottomRightTitleController) {
    timeline.add(bottomRightTitleController.getTimeline('out') as gsap.core.Timeline, 0.1);
  }

  if (kanjiController) {
    timeline.add(kanjiController.getTimeline('out') as gsap.core.Timeline, 0);
  }
}
